import { Routes } from '@angular/router';
import { InterviewComponent } from './../components/layout/interview/interview.component';
import {EditAddressPageComponent} from '../components/mpq3-dr/pages/edit-address/edit-address-page.component';
import {InitInterviewComponent} from '../components/general/init-interview/init-interview.component';

export const ROUTES: Routes = [
  {
    path: 'EditAddress',
    component: EditAddressPageComponent
  },
  {
    path: 'DiscountOptions',
    component: EditAddressPageComponent
  },
  {
    path: 'EditAddress/:isLoader',
    component: EditAddressPageComponent
  },
  {
    path: 'InitInterview',
    component: InitInterviewComponent
  },
  {
    path: '**',
    component: InterviewComponent
  }
];
